<template>
  <v-container fluid align-start ma-0 pa-2 class="container-height">
    <v-row no-gutters fill-height>
      <v-col cols="12">
        <i-card-vertical :headerTitle="menuTitle" >
          <template v-slot:body>
            <v-layout column >
              <v-row>
                <v-col cols="12" class="pa-0">
                  <i-card-top
                    class="d-md-flex"
                    outlined
                    :useBtnList="[
                      'btnRetrieve',
                      'btnPorSheet',
                      'btnBomList',
                      'btnSuccessList',
                    ]"
                    @btnRetrieve="btnRetrieve" @btnPorSheet="btnPorSheet" @btnBomList="btnBomList"
                    @btnSuccessList="btnSuccessList"
                  >
                    <template v-slot:body>
                      <v-row>
                        <v-col cols="4">
                          <span class="subMessege"> * This is not P.O. (Waiting Approval). </span>
                        </v-col>
                      </v-row>
                    </template>
                  </i-card-top>
                </v-col>
              </v-row>
              <v-row dense class="form-layout">
                <v-col cols="12" class="pa-0">
                  <v-row no-gutters>
                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                      <span>PO No</span>
                    </v-col>
                    <v-col cols="3">
                      <v-text-field 
                        v-model="formData.poNo" 
                        dense 
                        outlined 
                        hide-details="auto"
                        clearable 
                        backgroundColor="rgb(255,255,232)"
                        maxLength="30"
                        @keydown.enter="btnRetrieve()"
                      />
                    </v-col>
                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                      <span>Ship No</span>
                    </v-col>
                    <v-col cols="7">
                      <v-text-field 
                        v-model="formData.shipNo" 
                        dense 
                        outlined 
                        hide-details="auto"
                        readonly
                      />
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                      <span>Quotation No</span>
                    </v-col>
                    <v-col cols="3">
                      <v-text-field 
                        v-model="formData.QuotationNo" 
                        dense 
                        outlined 
                        hide-details="auto"
                        backgroundColor="rgb(255,255,232)"
                        readonly
                      />
                    </v-col>
                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                      <span>Supplier</span>
                    </v-col>
                    <v-col cols="3">
                      <v-text-field 
                        v-model="formData.supplier" 
                        dense 
                        outlined 
                        hide-details="auto"
                        readonly
                      />
                    </v-col>
                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                      <span>PO Amount</span>
                    </v-col>
                    <v-col cols="1/2">
                      <v-text-field 
                        v-model="formData.amount" 
                        dense 
                        outlined 
                        hide-details="auto"
                        readonly
                        backgroundColor="rgb(255,255,232)"
                        style="fontWeight:bold;"
                      />
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                      <span>Charger</span>
                    </v-col>
                    <v-col cols="3">
                      <v-text-field 
                        v-model="formData.charger" 
                        dense 
                        outlined 
                        hide-details="auto"
                        readonly
                      />
                    </v-col>
                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                      <span>FAX</span>
                    </v-col>
                    <v-col cols="3">
                      <v-text-field 
                        v-model="formData.fax" 
                        dense 
                        outlined 
                        hide-details="auto"
                        readonly
                      />
                    </v-col>
                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                      <span>Trans. Fee</span>
                    </v-col>
                    <v-col cols="3">
                      <v-text-field 
                        v-model="formData.transFee" 
                        dense 
                        outlined 
                        hide-details="auto"
                        readonly
                        backgroundColor="rgb(255,255,232)"
                        style="fontWeight:bold;"
                      />
                    </v-col>
                  </v-row>

                  <v-row no-gutters>
                    <v-col cols="4" >
                      <v-row no-gutters class="row__select-no">
                        <v-col cols="3" align="right" class="pr-2 pt-2 formHeader">
                          <span>Request<br>Employee</span>
                        </v-col>
                        <v-col cols="9" class="quotNo">
                          <v-text-field 
                            v-model="formData.request" 
                            outlined 
                            hide-details="auto"
                            readonly
                            height="60"
                          />
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="4" class="quotNo">
                      <v-row no-gutters >
                        <v-col cols="3" align="right" class="pb-1 pr-2 pt-1 formHeader" >
                          <span >Transport</span>
                        </v-col>
                        <v-col cols="9">
                          <v-text-field 
                            v-model="formData.transport" 
                            dense 
                            outlined 
                            hide-details="auto"
                            readonly
                          />
                        </v-col>
                      </v-row>
                      <v-row no-gutters class="row__select-no">
                        <v-col cols="3" align="right" class="pb-1 pr-2 pt-1 formHeader">
                          <span>Payment</span>
                        </v-col>
                        <v-col cols="9">
                          <v-text-field 
                            v-model="formData.payment" 
                            dense 
                            outlined 
                            hide-details="auto"
                            readonly
                          />
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="4" class="quotNo">
                      <v-row no-gutters >
                        <v-col cols="3" align="right" class="pb-1 pr-2 pt-1 formHeader">
                          <span>Gov. Fee</span>
                        </v-col>
                        <v-col cols="9" align="right">
                          <v-text-field 
                            v-model="formData.govFee" 
                            dense 
                            outlined 
                            hide-details="auto"
                            readonly
                            backgroundColor="rgb(255,255,232)"
                            style="fontWeight:bold;"
                          />
                        </v-col>
                      </v-row>
                      <v-row no-gutters class="row__select-no">
                        <v-col cols="3" align="right" class="pb-1 pr-2 pt-1 formHeader">
                          <span>Total</span>
                        </v-col>
                        <v-col cols="9" align="right">
                          <v-text-field 
                            v-model="formData.total" 
                            dense 
                            outlined 
                            hide-details="auto"
                            readonly
                            backgroundColor="rgb(255,255,232)"
                            style="fontWeight:bold;"
                          />
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="12" class="pt-1">
                  <DxDataGrid id="epms4030" 
                    class="hipGridHeight5_2" 
                    :ref="epms4030Ref"
                    :data-source="gridMainList" 
                    :remote-operations="false" 
                    :hover-state-enabled="true"
                    :allow-column-resizing="true" 
                    :allow-column-reordering="true"
                    :row-alternation-enabled="true" 
                    :show-borders="true" 
                    :width="grid.width"
                    :show-row-lines="true" 
                    key-expr="id" 
                    :focused-row-enabled="true"
                    :column-hiding-enabled="false" 
                    :selection="{ mode: 'none' }"
                    @cellPrepared="cellPrepared"
                  >
                    <DxEditing :use-icons="true" />
                    <DxColumn data-field="no" caption="No" width="3%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn caption="Ship No" width="10%" data-type="string" alignment="center" :allow-editing="false" >
                      <DxColumn data-field="shipNo" caption="POR No" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    </DxColumn>
                    <DxColumn data-field="matlCd" caption="Material Code" width="10%" data-type="left" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="matlSpec" caption="Material Specification" width="28%" data-type="left" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="matlUnit" caption="Unit" width="5%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn caption="P.O. Qty" width="9%" data-type="string" alignment="right" :allow-editing="false" >
                      <DxColumn data-field="poQty" caption="Unit Price" width="9%" data-type="string" alignment="right" :allow-editing="false"/>
                    </DxColumn>
                    <DxColumn caption="P.O. Amount" width="9%" data-type="string" alignment="right" :allow-editing="false" >
                      <DxColumn data-field="poAmt" caption="Trans. Fee" width="9%" data-type="string" alignment="right" :allow-editing="false" />
                    </DxColumn>
                    <DxColumn caption="VAT" width="3%" data-type="string" alignment="center" :allow-editing="false" >
                      <DxColumn data-field="poVat" caption="VAT" width="3%" data-type="string" alignment="center" :allow-editing="false" />
                    </DxColumn>

                    <DxColumn data-field="govFee" width="10%" data-type="string" alignment="right" :allow-editing="false" header-cell-template="headerTemplate" />
                    <template #headerTemplate>
                      <div>Gov. Fee<br>(U/Price)</div>
                    </template>

                    <DxColumn caption="W/H Req. Date" width="10%" data-type="string" alignment="center" :allow-editing="false" >
                      <DxColumn data-field="whReqDte" caption="Req. Dely. Date" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    </DxColumn>

                    <DxColumn data-field="certYn" caption="Cert Y/N" width="5%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxPaging :enabled="true" :page-size="30" />
                  </DxDataGrid>
                  <div :style="filePath != null && filePath != '' ? '' : 'display:none;' " @click="fileOpen">
                    <v-icon color="blue">$folder</v-icon><span class="pl-1 drawing" >View Attached File</span>
                  </div>
                  <div :style="dwgCount > 0 ? '' : 'display:none;' ">
                    <v-icon color="blue">$folder</v-icon><span class="pl-1 drawing" @click="drawingPage">View Drawing Page</span>
                  </div>
                </v-col>
              </v-row>
            </v-layout>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
    <drawingPagePop v-if="showPop" :showPop.sync="showPop" :paramNo="poNo" :gbn="'PO'" />
  </v-container>
</template>

<script>
import { DxDataGrid, DxEditing, DxColumn  } from 'devextreme-vue/data-grid'
import ICardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import baseview from '@/components/base/baseview.vue' // base page 추가
import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // 데이타 그리드 사용시 베이스 추가
import { getSuccessDetail , getSuccessDetailGrid } from '@/api/view/hip/4/epms4030.js'
import { getDwgCountByPO } from '@/api/view/hip/common/common.js'
import drawingPagePop from '@/views/hip/common/drawingPagePop';
import { reportView } from '@/api/view/hip/common/common.js'
import { getNumComma } from '@/utils/common.js'
import { ftpDownload} from '@/api/view/hip/common/common.js'

export default {
  name: 'epms4030',
  mixins: [baseview, BaseDataGrid],
  components: {
    ICardVertical,
    'i-card-top': iCardTop,
    DxDataGrid,
    DxColumn,
    DxEditing,
    drawingPagePop
  },
  data() {
    return {
      menuTitle: this.$route.meta.title,
      formData: {
        poNo: '' , shipNo: '', QuotationNo: '', supplier: '', amount: '', charger: '', fax: '', transFee: '' ,transport: '', 
        payment: '', govFee: '', total: '' ,request: ''
      },

      epms4030Ref: 'epms4030Ref',
      gridMainList: [],

      nonDispalyedRowIndex: [],
      curRowIndex: 0,

      poNo: '',
      dwgCount: 0,
      filePath: '',
      showPop: false,
      sys: this.$store.state.system.sysCd

    }
  },
  computed: {
    gridMainInstance() {
      return this.GetDataGrid(this.epms4030Ref)
    },
  },
  mounted() {
    if(this.$route.params.poNo){
      this.gridMainList = []
      this.poNo = this.$route.params.poNo
      this.doSearchDwg()
      this.doSearchMain()
      this.doSearchGrid()
    }
  },
  methods: {
    async doSearchDwg(){
      this.dwgCount = 0
      let params = {
        poNo: this.poNo,
      }
      await getDwgCountByPO(params)
      .then( res => {
        this.dwgCount = res.list[0].tcnt
      }).catch(error => {})
    },
    async doSearchMain(){
      this.formData = {}
      this.filePath = ''
      this.openLoading('searching')
      let params = {
        makerCd: this.$store.state.user.makerCd,
        poNo: this.poNo,
      }
      await getSuccessDetail(params).then(res => {
        if(res.list.length){
          let list = res.list[0]
          this.formData = {
            poNo: list.poNo , shipNo: list.shipNm, QuotationNo: list.quotNo, supplier:list.makerNm, amount: getNumComma(list.poAmt), 
            charger:list.buyerNm, fax: list.makerFax, transFee: list.transFee ,transport: list.transCond, 
            payment: list.payCond, govFee: list.govFee, total: getNumComma(list.totAmt) + ' ' + list.moneUnit ,request: list.reqDept,
            shipNo: list.shipNo
          }
          this.filePath = list.filePath
        }
      }).finally(() => {
        this.endLoading()
      })
    },
    async doSearchGrid(){
      this.gridMainList = []
      this.openLoading('searching')
      let params = {
        makerCd: this.$store.state.user.makerCd,
        poNo: this.poNo,
      }
      await getSuccessDetailGrid(params).then(res => {
        if(res.list.length){
          let no = 1;
          let cnt = 0;
          res.list.forEach(e => {
            this.gridMainList.push(
              {
                no: no, shipNo: e.shipNo, matlCd: e.matlCd, matlSpec: e.matlSpec, matlUnit: e.matlUnit, poQty: getNumComma(e.poQty), poAmt: getNumComma(e.poAmt), 
                poVat: e.poVat, govFee: e.govFee, whReqDte: e.whReqDte, certYn: e.certYn, id: cnt++
              },
              {
                no: no, shipNo: e.porNo, matlCd: e.matlCd, matlSpec: e.matlSpec, matlUnit: e.moneUnit, poQty: getNumComma(e.poUprice), poAmt: getNumComma(e.transFee), 
                poVat: e.transVat, govFee: e.govFee, whReqDte: e.reqDlyDte, certYn: e.certYn, id: cnt++
              }
            )
            no++
          });
        }
      }).finally(() => {
        this.endLoading()
      })    },
      cellPrepared(e){
      if(e.rowType === 'data'){
        if(e.column.dataField === 'no' || e.column.dataField === 'matlCd' || e.column.dataField === 'matlSpec' 
        || e.column.dataField === 'govFee' || e.column.dataField === 'certYn' ){
          if(e.data.id % 2 === 0){
          e.cellElement.setAttribute('rowspan', 2)
          } else {
          e.cellElement.style.display = 'none'
          }
        } 
        if(e.column.dataField === 'matlSpec'){
          e.cellElement.style['text-align'] = 'left'
        }
      }
    },
    btnRetrieve(){
      this.poNo = !this.formData.poNo ? '' : this.formData.poNo
      this.doSearchMain()
      this.doSearchGrid()
      this.doSearchDwg()
    },
    btnPorSheet(){
      const param = {
        fileName: 'por_sheet.jrxml',
        as_quot_no: this.formData.poNo
      }
      this.openLoading('searching')
      reportView(param)
      .finally(() => {
        this.endLoading()
      })
    },
    btnBomList(){
      const param = {
        fileName: 'bom_list.jrxml',
        as_quot_no: this.formData.poNo
      }
      this.openLoading('searching')
      reportView(param)
      .finally(() => {
        this.endLoading()
      })
    },
    btnSuccessList(){
      this.$router.push('epms4020');
    },
    drawingPage(){
      this.showPop = true
    },
    fileOpen(e){
      const file = this.filePath
      this.openLoading('searching')
      ftpDownload(file)
      .finally(() => {
        this.endLoading()
      })
    },
  }
}
</script>
<style lang="scss" scoped>
.form-layout::v-deep .col {
  border-width: 1px 0 0 1px;
  border-style: solid;
  border-color: gray;
  
  * {
    border: 0px none !important;
  }

  .row:not(.row__select-no) {
    border-width: 0 0 1px 0 !important;
    border-style: solid !important;
    border-color: gray !important;
  }

  .col:not(.quotNo) {
    border-width: 0 1px 0 0 !important;
    border-style: solid !important;
    border-color: gray !important;
  }
}
.formHeader {
  background-color: rgb(223, 227, 213);
  font-weight: bold;
  border: 1px solid gray;
  border-bottom: 0px;
  color: black;
}
.subMessege {
  color: red;
  font-weight: bold;
}
.drawing {
  font-size: 10pt;
  color: black;
  cursor: pointer;
}
.drawing:hover{
  color: #4980BC;
}
</style>